// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"84":"572eeab902498e1b","182":"06a935ab6c194644","641":"06a935ab6c194644"}[chunkId] + ".css";
};